import { getAccountCampaignSummary } from "../types/account_campaign_summary_types";

const initState = {
  data: [],
  channel: "",
  loading: false,
  error: null
};

export default function accountCampaignSummaryReducer(state = initState, action = {}) {
  switch (action.type) {
    case getAccountCampaignSummary.GET_ACCOUNT_CAMPAIGN_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getAccountCampaignSummary.GET_ACCOUNT_CAMPAIGN_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        channel: action.payload.channel,
        error: null,
      };
    case getAccountCampaignSummary.GET_ACCOUNT_CAMPAIGN_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
